import { Observable } from "rxjs";
import { Injectable } from "@angular/core";
import { UseCase } from "../../base";
import { HttpResponse } from "@angular/common/http";
import { LocationsRepository } from "../../repositories";

@Injectable({providedIn: 'root'})
export class GetLocationsImportSampleFileUsecase implements UseCase<unknown, HttpResponse<Blob>>
{
    constructor(private locationRepository: LocationsRepository){}

    execute(): Observable<HttpResponse<Blob>> {
        return this.locationRepository.getSampleLocationsImportFiles();
    }
}